import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ParkStat } from '../models/park-stats';
import { catchError } from 'rxjs/operators';

@Injectable()
export class BikesUsageService {

  BIKE_USAGE_URL = environment.serverUrl + "api/1/park/bikes/";

  constructor(private http : HttpClient) { }

  getBikeUsageStats() : Observable<ParkStat> {
    return this.http.get<ParkStat>(this.BIKE_USAGE_URL + "count/count-by-state").pipe(
      catchError(err => of({} as ParkStat))
    )
  }

  getInUseBikeStats() : Observable<ParkStat> {
    return this.http.get<ParkStat>(this.BIKE_USAGE_URL + "count/count-by-type/available");
  }

  getinCirculationBikeStats() : Observable<ParkStat>{
    return this.http.get<ParkStat>(this.BIKE_USAGE_URL + "count/count-by-type/count-on-the-road");
  }

  getBrokenDownBikesStats(): Observable<ParkStat>{
    return this.http.get<ParkStat>(this.BIKE_USAGE_URL + "count/count-by-type/broken-down");
  }

  getMaintainanceStats() : Observable<ParkStat>{
    return this.http.get<ParkStat>(this.BIKE_USAGE_URL + "count/count-by-type/under-maintenance");
  }

}



// WEBPACK FOOTER //
// ./src/app/statistics/bikes-usage.service.ts